import { jsx as _jsx } from "react/jsx-runtime";
import { useGrowthPursuitGraphEnabled } from '../../../GrowthHub/growthFlags';
import { GraphPanel } from '../../GraphPanel';
import { useCaptureWorkspace } from '../../hooks';
import { usePursuitRecord } from '../PursuitRecordContext';
import { PursuitSectionFrame } from '../PursuitSectionFrame';
/**
 * Knowledge graph (Working papers). With growth_pursuit_graph_v1 (GRW-35) the
 * panel shows this pursuit's part of the graph projection and "Add to this
 * pursuit" writes link rows; off = today's whole-tenant panel.
 */ export function GraphSection() {
    const { captureProjectId, header } = usePursuitRecord();
    const { data } = useCaptureWorkspace(captureProjectId);
    const pursuitGraph = useGrowthPursuitGraphEnabled();
    const highlightRef = header?.opportunity?.customer?.id || data?.summary?.customerOrgId;
    return /*#__PURE__*/ _jsx(PursuitSectionFrame, {
        title: "Knowledge graph",
        children: /*#__PURE__*/ _jsx(GraphPanel, {
            highlightRef: highlightRef,
            scope: pursuitGraph ? {
                kind: 'pursuit',
                captureProjectId
            } : {
                kind: 'tenant'
            },
            hasCustomer: !!(header?.opportunity?.customer?.id || data?.summary?.customerOrgId),
            hasVehicle: !!header?.opportunity?.vehicle?.id
        })
    });
}
